import AbstractRuleSpecification from 'kaspi.frontend/src/modules/ruleSpecification/AbstractRuleSpecification'

export default class IsMobileApp extends AbstractRuleSpecification {
  constructor () {
    super()

    this._reasonNotSatisfied = 'Не мобильное приложение'
  }

  _executeCheckIsSatisfiedBy (mobapp) {
    return typeof mobapp !== 'undefined'
  }
}
